<div class="p-3">
    <div class="d-flex flex-row align-items-center justify-content-between">
        <h3 class="mb-0">Game Lock</h3>
        <button class="btn btn-sm" (click)="close()">CLOSE</button>
    </div>
    <hr/>

    <div *ngIf="!lock.status && lock.message">
        <h5 class="text-danger">{{lock.message}}</h5>
    </div>

    <div *ngIf="lock.status">
        <h3>Player is current in <b><u>{{lock.game_title}}</u></b>.</h3>
        <button (click)="withdrawExit()">Withdraw & Exit Game</button>
    </div>
    
</div>